import BeerBackgroundMobileSVG from '@/assets/images/login/background-beer-sm.svg';
import WineBackgroundMobileSVG from '@/assets/images/login/background-wine-sm.svg';
import BeerSelectionSVG from '@/assets/images/login/beer-icon.svg';
import EthanolSVG from '@/assets/images/login/ethanol.svg';
import WineSelectionSVG from '@/assets/images/login/wine-icon.svg';
import { Theme } from '@/utils/types';

export type LoginThemeSettingsType = typeof settings;

export const settings = {
  [Theme.Wine]: {
    method: Theme.Wine,
    title: 'login.fermentationWineLogin', // translation key
    loginCardThumbnail: WineSelectionSVG,
    titleDeviderColor: 'bg-[#C73C9D]',
    inputBorderColor: 'focus:!border-[#C73C9D]',
    backgroundColor: 'bg-[#F0BBE0]',
    loginButtonBackgroundColor: '!bg-[#C73C9D]',
    loginButtonDropShadowColor: 'drop-shadow-[0_3px_10px_rgba(226,9,103,0.4)]',
    forgotPasswordLinkColor: 'text-[#C73C9D]',
    backgroundImage: 'bg-wine',
    mobileBackgroundImage: WineBackgroundMobileSVG,
    mobileCurve: 'bg-wine-mobile-curve',
    loginMethodButtonColor: 'text-[#C73C9D]',
    disableLoginMethod: false,
  },
  [Theme.Beer]: {
    method: Theme.Beer,
    title: 'login.betterBrewingLogin', // translation key
    loginCardThumbnail: BeerSelectionSVG,
    titleDeviderColor: 'bg-[#005007]',
    inputBorderColor: 'focus:!border-[#005007]',
    backgroundColor: 'bg-[#D7F6B2]',
    loginButtonBackgroundColor: '!bg-[#005007]',
    loginButtonDropShadowColor: 'drop-shadow-[0_3px_10px_rgba(0,80,7,0.4)]',
    forgotPasswordLinkColor: 'text-[#008A00]',
    backgroundImage: 'bg-beer',
    mobileBackgroundImage: BeerBackgroundMobileSVG,
    mobileCurve: 'bg-beer-mobile-curve',
    loginMethodButtonColor: 'text-[#005007]',
    disableLoginMethod: false,
  },
  [Theme.Ethanol]: {
    method: Theme.Ethanol,
    title: 'login.BioEthanolLogin', // translation key
    loginCardThumbnail: EthanolSVG,
    titleDeviderColor: 'bg-[#117ea6]',
    inputBorderColor: 'focus:!border-[#117ea6]',
    backgroundColor: 'bg-[#b1e3f5]',
    loginButtonBackgroundColor: '',
    loginButtonDropShadowColor: 'drop-shadow-[0_3px_10px_rgba(10,76,101,0.4)]',
    forgotPasswordLinkColor: 'text-[#117ea6]',
    backgroundImage: 'bg-ethanol',
    mobileBackgroundImage: EthanolSVG,
    mobileCurve: '',
    loginMethodButtonColor: 'text-[#117EA6]',
    disableLoginMethod: false,
  },
};
